import { CombinedQuestionStats } from "../view-survey.types";
import ResultsQuestion from "./results-question.component";
import { ReactElement, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ResultsQuestionListHeader from "./results-question-list-header.component";
import { useViewSurveyChildren, ViewSurveyChildrenProps } from "../../survey-results/useViewSurveyChildren";
import { useGetSurveyAudienceQuery } from "src/redux/survey/survey.endpoints";
import { PulsePollingSurveyDataJSON } from "src/redux/survey/survey.types";

export enum ResultsQuestionListTab {
  Summary, Responses, Demographics, PulsePolling
}

interface ResultsQuestionListProps extends ViewSurveyChildrenProps {
  readonly questions: CombinedQuestionStats[];
  readonly aiMaxCompletes?: number;
  readonly humanMaxCompletes?: number;
  readonly audienceId: string;
  readonly isShare: boolean;
  readonly pulsePollingData?: PulsePollingSurveyDataJSON;
}

const ResultsQuestionList = ({ questions, aiMaxCompletes, humanMaxCompletes, surveyId, audienceId, isShare, pulsePollingData }: ResultsQuestionListProps): ReactElement => {
  const [activeTab, setActiveTab] = useState<ResultsQuestionListTab>(ResultsQuestionListTab.Summary);
  const [searchParams] = useSearchParams();
  const lastAnimatedIndex = useRef('0');
  const { survey, stats } = useViewSurveyChildren(surveyId, isShare);

  const { criteria } = useGetSurveyAudienceQuery({ id: audienceId, isShare }, {
    skip: !audienceId,
    selectFromResult: ({ data }) => ({ criteria: data?.criteria }),
  });

  useEffect(() => {
    const questionIndex = searchParams.get('question');
    if (questionIndex && questionIndex !== 'summary' && questionIndex !== lastAnimatedIndex.current) {
      const element = document.getElementById(`results-question-${questionIndex}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        lastAnimatedIndex.current = questionIndex;
      }
    }
  }, [searchParams]);


  const onTabChange = (tab: ResultsQuestionListTab) => {
    setActiveTab(tab);
  };

  return (
    <div className='flex flex-col'>
      <ResultsQuestionListHeader
        initialTab={activeTab}
        onTabChange={onTabChange}
        pulsePollingData={pulsePollingData}
      />
      <div className="flex flex-col gap-4">
        {questions.map((question, index) => (
          <ResultsQuestion
            key={question.id}
            listTab={activeTab}
            question={question}
            index={index}
            aiMaxCompletes={aiMaxCompletes}
            humanMaxCompletes={humanMaxCompletes}
            surveyId={surveyId}
            initialFilter={criteria}
            surveyStatus={survey?.surveyStatus}
            pulsePollingData={pulsePollingData}
            // @ts-expect-error aiUsers is actually an object with total
            aiUserTotal={stats?.aiUsers.total}
            // @ts-expect-error humanUsers is actually an object with total
            humanUserTotal={stats?.humanUsers.total}
          />
        ))}
      </div>
    </div>
  );
};

export default ResultsQuestionList;
